import { UserProgressStatus } from './user-status';

export enum UserTypeEnum {
  Internal = 'internal',
  ExternalStakeHolder = 'external_stakeholder',
  Auditor = 'auditor',
}

/**
 * Anecdotes API
 * Anecdotes API's
 *
 * OpenAPI spec version: 0.0.3
 * Contact: apiteam@anecdotes.ai
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface User {
  first_name?: string;
  last_name?: string;
  /**
   * The user role
   */
  role?: RoleEnum;
  email?: string;
  last_login?: number;
  status?: UserProgressStatus;
  audit_id?: string;
  audit_frameworks?: string[];
  photo?: string;
  uid?: string;
  scim_provisioned?: boolean;
}

export type RoleEnum = 'admin'
  | 'user'
  | 'auditor'
  | 'it'
  | 'collaborator'
  | 'auditors_zone'
  | 'reviewer'
  | 'stakeholder_role'
  | 'trustcenter_access_manager'
  | 'contributor_role'
  | 'viewer_role';

export const RoleEnum = {
  Admin: 'admin' as RoleEnum,
  Collaborator: 'collaborator' as RoleEnum,
  Manager: 'collaborator' as RoleEnum,
  User: 'user' as RoleEnum,
  Auditor: 'auditor' as RoleEnum,
  It: 'it' as RoleEnum,
  Reviewer: 'reviewer' as RoleEnum,
  Stakeholder: 'stakeholder_role' as RoleEnum,
  Zone: 'auditors_zone' as RoleEnum, // This is the auditors portal (aka zone) role
  TrustCenterAccessManager: 'trustcenter_access_manager' as RoleEnum,
  Contributor: 'contributor_role' as RoleEnum,
  Viewer: 'viewer_role' as RoleEnum,
};
